import React, { useEffect, useState } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import api from '../api'; // Assurez-vous que api est configuré avec { withCredentials: true }

const ProtectedRoute = ({ allowedRoles, children }) => {
  const location = useLocation();
  const [isLoading, setIsLoading] = useState(true);
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [userRole, setUserRole] = useState(null);

  useEffect(() => {
    const checkAuth = async () => {
      try {
        // Vérifier l'authentification via l'API /me
        const response = await api.get('/me', { withCredentials: true });

        if (!response.data.success || !response.data.user) {
          setIsAuthenticated(false);
          setUserRole(null);
          setIsLoading(false);
          return;
        }

        const roleId = parseInt(response.data.user.role_id, 10);
        if (isNaN(roleId)) {
          setIsAuthenticated(false);
          setUserRole(null);
          setIsLoading(false);
          return;
        }

        // Vérifier si le rôle est autorisé
        if (!allowedRoles.includes(roleId)) {
          setIsAuthenticated(false);
          setUserRole(roleId);
        } else {
          setIsAuthenticated(true);
          setUserRole(roleId);
        }

      } catch (error) {
        console.error('Erreur lors de la vérification d\'authentification:', error);
        setIsAuthenticated(false);
        setUserRole(null);
      } finally {
        setIsLoading(false);
      }
    };

    checkAuth();
  }, [allowedRoles]);

  const getRedirectPath = (roleId) => {
    const roleRoutes = {
      1: '/client/home',
      2: '/admin',
      3: '/ChefProjet/home',
      4: '/technique/home',
      5: '/fonctionelle/home',
      6: '/admin-client/home',
      7: '/super-admin/home',
      8: '/dg/demande'
    };
    return roleRoutes[roleId] || '/login';
  };

  if (isLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-indigo-600 mx-auto"></div>
          <p className="mt-4 text-gray-600">Vérification des autorisations...</p>
        </div>
      </div>
    );
  }

  // Non authentifié → login
  if (!isAuthenticated && !userRole) {
    return (
      <Navigate
        to="/login"
        replace
        state={{
          from: location.pathname,
          message: 'Veuillez vous connecter pour accéder à cette page'
        }}
      />
    );
  }

  // Authentifié mais rôle non autorisé → redirection selon rôle
  if (!isAuthenticated && userRole) {
    const redirectPath = getRedirectPath(userRole);
    return (
      <Navigate
        to={redirectPath}
        replace
        state={{
          message: 'Vous n\'êtes pas autorisé à accéder à cette page'
        }}
      />
    );
  }

  // Tout est OK → afficher la route
  return children;
};

export default ProtectedRoute;
